import { xml2js } from 'xml-js';
import { ATTRS, TAGS, TIMELOG_TYPES } from '../constants';
import { EntitiesManager } from '../entitiesManager';
import { Entity, ISOFileInformation } from '../types';
import { TimeEntity } from './Time';

export class TimeLogEntity implements Entity {
  public static fromXML(
    xml: any,
    matchIDs: any,
    files: ISOFileInformation[],
    entitiesManager: EntitiesManager
  ) {
    const filename = xml._attributes[ATTRS.TimeLog.Filename];

    const regex = new RegExp(`${filename}\\.XML$`, 'i');
    const file = files.find((f) => !!f.filename.match(regex));

    const parsedXML = xml2js(file.data as string, { compact: true, alwaysArray: true });

    const timeEntity = TimeEntity.fromXML(
      parsedXML[TAGS.Time][0],
      matchIDs,
      files,
      entitiesManager
    ).entity;

    return {
      entity: new TimeLogEntity(xml._attributes[ATTRS.TimeLog.Filename], timeEntity),
    };
  }
  public type = TAGS.TimeLog;
  public id: string;

  constructor(
    public filename: string,
    public time: TimeEntity
  ) {
    this.id = filename;
  }

  // generation of external files (XML and BIN) is not implemented
  public toXML() {
    return {
      _attributes: {
        [ATTRS.TimeLog.Filename]: this.filename,
        [ATTRS.TimeLog.TimeLogType]: TIMELOG_TYPES.BinaryTimeLogFile,
      },
    };
  }
}
